import styled from 'styled-components';
import { Type } from '../types'

export const SectionError = styled.section`
color: ${(props: Type) => props.theme.error.textColor};
`
